import React from 'react';
import { useForm } from 'react-hook-form';
import { useCreateRegisteredStaffPost } from './apiEndpoints/registeredVisitorEndpoint';
import StaffForm from './StaffForm';
interface AddNewVisitorProps {
  onAddVisitor: () => void; // Modify the type according to your requirements
}
const AddNewVisitor: React.FC<AddNewVisitorProps> = ({ onAddVisitor }) => {
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    resetField,
    formState: { errors },
  } = useForm<any>();

  const { mutate, isSuccess, isPending } = useCreateRegisteredStaffPost();

  if (isSuccess) {
    onAddVisitor();
  }
  const onSubmit = async (data: any) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'object') {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });
    mutate(formData);
  };
  return (
    <div className='profile-right-side px-3 py-3 mb-2'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <StaffForm
          register={register}
          setValue={setValue}
          clearErrors={clearErrors}
          resetField={resetField}
          errors={errors}
          setError={setError}
          btnText='Add Staff'
          loading={isPending}
          imageRequired
        />
      </form>
    </div>
  );
};

export default AddNewVisitor;
